var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _c("h2", [_vm._v(_vm._s(_vm.$ct("sub-title")))]),
              ]),
              _c("w-col", { attrs: { xs: "12", md: "6" } }, [
                _c("p", { domProps: { innerHTML: _vm._s(_vm.$ct("p1")) } }),
                _c("p", { domProps: { innerHTML: _vm._s(_vm.$ct("p2")) } }),
              ]),
              _c("w-col", { attrs: { xs: "12", md: "12" } }, [
                _c("p", [
                  _c(
                    "a",
                    {
                      staticClass: "w-button mr",
                      attrs: {
                        target: "_blank",
                        href: "https://winfakt.be/assets/remote/index.php",
                      },
                    },
                    [
                      _c("w-fa", {
                        staticClass: "mr",
                        attrs: { icon: ["far", "life-ring"] },
                      }),
                      _vm._v(_vm._s(_vm.$ct("start-remote-help")) + " "),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }